import "bootstrap/dist/css/bootstrap.min.css";
import { LoadingIkon } from "../../utils/Ikonok";

export const Loading = ({ size = "40px" }) => {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center"
      style={{ height: "100vh" }}
    >
      <div>
        <LoadingIkon />
        <div
          style={{ marginTop: "8px", fontSize: "1.2rem", textAlign: "center" }}
        >
          Betöltés folyamatban...
        </div>
      </div>
    </div>
  );
};

export default Loading;
